export default function Character() {}
Character.isWhitespace = function (c) {
  return c <= 32 && c >= 0 || c === 127;
};
Character.toUpperCase = function (c) {
  return c.toUpperCase();
};